<template>
  <div class="myIntegral">
    <van-nav-bar
      title="我的积分"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
		<div class="all_integral">
			<div>总积分</div>
			<div>{{ integral }}</div>
		</div>
		<div class="integral_detail">积分明细</div>
		<div class="signIn_list" v-if="signInList">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="item" v-for="(item, index) in signInList" :key="index">
					<div>
						<span>{{ item.desc }}</span>
						<span>{{item.create_time | formatDate}}</span>
						</div>
						<div>
						<span>{{ item.num }}</span>
					</div>
				</div>
			</van-list>
		</div>
		<van-empty v-if="!signInList" class="custom-image" :image="emptyImg" description="暂无数据" />
    </div>
  </div>
</template>

<script>
// import {integralLog} from "@/components/model";
export default {
	name: "",
	data() {
		return {
			emptyImg: require("../../assets/images/kong.png"),
			loading: false,
			finished: false,
			refreshing: false,
			page:0,
			integral:0,
			signInList:[]
		};
	},
	mounted() {
		this.$toast.loading({
		  message: "数据加载中...",
		  forbidClick: true,
		  duration: 500,
		});
	},
	methods: {
		onClickLeft() {
		  this.$router.go(-1);
		},
		async onLoad() {
			this.page = this.page+1;
			let _this = this;
			let res = await integralLog(_this.page);
			this.integral = res.data.integral;
			if (res) {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				for (var i = 0; i < res.data.list.length; i++) {
					this.signInList.push({
						desc: res.data.list[i]['desc'],
						create_time: res.data.list[i]['create_time'],
						num: res.data.list[i]['num'],
					});
				}
				this.loading = false;		
				if (this.page >= res.data.totalPage) {
					this.finished = true;
				}
			}
		},
	},
	filters: {
		formatDate: function (value) {
		let date = new Date(value * 1000);
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		}
	},
	components: {},
};
</script>

<style scoped lang="less">
.content /deep/ .van-empty__image {
    width: 90px;
    height: 90px;
}
.myIntegral{
    .content{
        height: 100vh;
        background-color: #f6f6f6;
        padding: 10px 25px;
        .all_integral{
            height: 110px;
            background-color: #ed4032;
            color: #fff;
            border-radius: 8px;
            text-align: center;
            div:nth-child(1){
                line-height: 70px;
            }
        }
        .integral_detail{
            margin-top: 20px;
            font-weight: bold;
        }
        .custom-image{
            margin-top: 60px;
        }
        
    }
}
</style>
 